import View from '../Support/View/View';

export default class Slider extends View {

    static get viewName() {
        return 'slider';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        this.#setBullets();

        setTimeout(() => new Glide(this.$el, this.options).mount(), 500);
    }

    /**
     * @returns {Object}
     */
    get options() {
        return {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            animationDuration: 200,
            ...(this.viewData?.options ?? {}),
        };
    }

    #setBullets() {
        if (!this.viewData.bullets) {
            return;
        }

        const container = this.$el.querySelector('.slider-bullets');
        const slides    = this.$el.querySelectorAll('.slider-slide');

        if (!container || !(slides.length > 1)) {
            return;
        }

        container.innerHTML = Array.from(slides).map((slide, index) => {
            return `<button class="slider-bullet glide__bullet" data-glide-dir="=${index}" aria-label="Item : ${index + 1}"></button>`;
        }).join('');

        container.hidden = false;
    }
}